import { Slug } from "./Slug";

export const wikiPage = { en: "Wiki Pages", ru: "Wiki Страницы" };

export function getTitle(titleEn: string | null, titleRu: string | null) {
  return {
    en: titleEn?.length ? titleEn : "No Title",
    ru: titleRu?.length ? titleRu : "Нет названия",
  };
}

export function generateUrl(id: number, slug: string | null): string {
  return slug ? Slug(id + " " + slug) : id.toString();
}
